export interface VideoItem {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  rating: number;
  year: number;
  region: string;
  description: string;
  duration: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
  updateEpisode: string;
  content: string;
  director: string;
  actors: string[];
  releasedAt: string;
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20space%20exploration%20scene%20with%20astronauts%20on%20a%20frozen%20planet%20surface%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20movie%20poster%20style%2C%20clean%20composition%2C%20high%20contrast&width=800&height=450&seq=video-thumb-01&orientation=landscape",
    rating: 9.2,
    year: 2026,
    region: "中国大陆",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，一群勇敢的年轻人挺身而出，为了人类的未来而战斗。",
    duration: "148分钟",
    tags: ["科幻", "灾难", "冒险", "国产大片"],
    views: 12890000,
    isHot: true,
    isNew: false,
    updateEpisode: "HD高清",
    content: "《流浪地球3》延续了前作的宏大叙事，讲述了人类在宇宙中寻找新家园的壮丽旅程。影片以震撼的视觉效果和深刻的人文关怀，展现了中国科幻电影的巅峰水准。本片不仅延续了前两部的故事线，更加入了全新的角色和更加复杂的剧情转折。特效场面令人叹为观止，情感内核更是打动人心。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    releasedAt: "2026-02-01",
  },
  {
    id: 2,
    title: "长安三万里2：诗仙归来",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20scene%20with%20poets%20in%20traditional%20robes%20under%20moonlight%2C%20ink%20wash%20painting%20aesthetic%2C%20golden%20warm%20tones%2C%20elegant%20atmospheric%20composition%2C%20cinematic%20lighting&width=800&height=450&seq=video-thumb-02&orientation=landscape",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    description: "诗仙李白的传奇人生再度被搬上银幕，以更加宏大的视角展现盛唐气象。影片以动画形式呈现唐代文化瑰宝。",
    duration: "168分钟",
    tags: ["动画", "历史", "文化", "唐诗"],
    views: 9860000,
    isHot: true,
    isNew: false,
    updateEpisode: "HD高清",
    content: "《长安三万里2》是追光动画继前作之后的又一力作。本片以更加成熟的动画技术和更加深入的叙事手法，再现了李白、杜甫等唐代诗人的传奇故事。影片画面精美绝伦，每一帧都如同一幅中国画，将盛唐时期的繁华与诗意展现得淋漓尽致。",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫"],
    releasedAt: "2026-07-15",
  },
  {
    id: 3,
    title: "狂飙2：暗流涌动",
    category: "tv",
    thumbnail: "https://readdy.ai/api/search-image?query=Dark%20thriller%20crime%20drama%20scene%20with%20Chinese%20police%20officers%20in%20a%20rainy%20city%20street%20at%20night%2C%20neon%20lights%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic&width=800&height=450&seq=video-thumb-03&orientation=landscape",
    rating: 9.5,
    year: 2026,
    region: "中国大陆",
    description: "扫黑除恶斗争再度升级，新的案件牵扯出更大的利益网络。一线刑警与犯罪集团展开新一轮的智勇较量。",
    duration: "45分钟/集",
    tags: ["犯罪", "悬疑", "刑侦", "热门剧集"],
    views: 25600000,
    isHot: true,
    isNew: true,
    updateEpisode: "更新至第12集",
    content: "《狂飙2》延续了第一季的高水准制作，以更加复杂的人物关系和更加紧张的剧情节奏，讲述了一线刑警在扫黑除恶斗争中的英勇事迹。剧情跌宕起伏，演员演技炸裂，是今年最值得追的国产剧集之一。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    releasedAt: "2026-06-01",
  },
  {
    id: 4,
    title: "深海危机",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Deep%20ocean%20submarine%20thriller%20scene%20with%20mysterious%20underwater%20creatures%20and%20submarine%20in%20dark%20blue%20water%2C%20suspenseful%20atmospheric%20lighting%2C%20cinematic%20movie%20poster%20aesthetic&width=800&height=450&seq=video-thumb-04&orientation=landscape",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    description: "深海科考队在一次例行任务中意外发现了一个惊天秘密。人类对海洋的探索才刚刚开始，而深海中隐藏的危险远超想象。",
    duration: "136分钟",
    tags: ["科幻", "惊悚", "冒险", "深海"],
    views: 7520000,
    isHot: false,
    isNew: true,
    updateEpisode: "HD高清",
    content: "《深海危机》是中国首部深海科幻惊悚片，以紧张的节奏和逼真的特效，带领观众深入马里亚纳海沟，探索人类未知的深海世界。影片融合了科幻与惊悚元素，在视觉和听觉上都给观众带来了极致体验。",
    director: "田晓鹏",
    actors: ["黄渤", "王俊凯"],
    releasedAt: "2026-05-20",
  },
  {
    id: 5,
    title: "乘风破浪的姐姐 第五季",
    category: "variety",
    thumbnail: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20women%20on%20a%20glamorous%20stage%20with%20spotlights%20and%20colorful%20stage%20design%2C%20variety%20show%20aesthetic%2C%20vibrant%20warm%20lighting%2C%20entertainment%20show%20atmosphere&width=800&height=450&seq=video-thumb-05&orientation=landscape",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    description: "全新一季的姐姐们再度集结！30位30+的女性艺人将通过舞台竞演展现无限魅力，诠释女性力量。",
    duration: "120分钟/期",
    tags: ["综艺", "音乐", "竞演", "女性力量"],
    views: 18900000,
    isHot: true,
    isNew: true,
    updateEpisode: "更新至第8期",
    content: "《乘风破浪的姐姐》第五季再度来袭，本季邀请了来自不同领域的30位姐姐，她们将在舞台上展现自己的才华和魅力。节目不仅是一场视觉盛宴，更传递了女性自信、独立、勇敢的精神力量。",
    director: "吴梦知",
    actors: ["宁静", "那英", "王心凌"],
    releasedAt: "2026-06-15",
  },
  {
    id: 6,
    title: "凡人修仙传 第四季",
    category: "anime",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20cultivation%20anime%20scene%20with%20a%20warrior%20in%20flowing%20robes%20flying%20above%20misty%20mountains%2C%20golden%20spiritual%20energy%20effects%2C%20epic%20landscape%2C%20anime%20art%20style&width=800&height=450&seq=video-thumb-06&orientation=landscape",
    rating: 9.3,
    year: 2026,
    region: "中国大陆",
    description: "韩立踏上新的修仙之路，面对更强大的敌人和更险恶的修真世界。凡人逆天改命的传奇仍在继续。",
    duration: "22分钟/集",
    tags: ["修仙", "玄幻", "3D动画", "国漫"],
    views: 15600000,
    isHot: true,
    isNew: false,
    updateEpisode: "更新至第56集",
    content: "《凡人修仙传》第四季继续讲述韩立的修仙之路。本季动画质量再度提升，打斗场面更加精彩，世界观也更加宏大。作为国产3D动画的标杆之作，本片在画面、剧情、配音等各方面都达到了新的高度。",
    director: "王裕仁",
    actors: ["钱文青", "李诗萌"],
    releasedAt: "2026-03-10",
  },
  {
    id: 7,
    title: "舌尖上的中国 第五季",
    category: "documentary",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20photography%20with%20steaming%20hot%20dishes%20on%20a%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20traditional%20Chinese%20cooking%20scene%2C%20appetizing%20food%20styling%2C%20documentary%20aesthetic&width=800&height=450&seq=video-thumb-07&orientation=landscape",
    rating: 9.4,
    year: 2026,
    region: "中国大陆",
    description: "继续探索中国各地的美食文化，从街头小吃到宫廷御膳，每一道美食背后都是一个动人的故事。",
    duration: "50分钟/集",
    tags: ["美食", "文化", "纪录片", "中国味道"],
    views: 11200000,
    isHot: false,
    isNew: true,
    updateEpisode: "更新至第6集",
    content: "《舌尖上的中国》第五季再次出发，走遍中国大江南北，探寻最地道的美食文化。本季特别关注了非遗美食和即将失传的传统手艺，在呈现美食的同时也记录了中国饮食文化的传承与变迁。",
    director: "陈晓卿",
    actors: ["李立宏"],
    releasedAt: "2026-04-20",
  },
  {
    id: 8,
    title: "神隐之岛",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20tropical%20island%20with%20ancient%20ruins%20covered%20in%20vines%2C%20golden%20sunset%20light%2C%20adventure%20movie%20aesthetic%2C%20lush%20green%20jungle%20and%20turquoise%20ocean%2C%20cinematic%20wide%20shot&width=800&height=450&seq=video-thumb-08&orientation=landscape",
    rating: 8.4,
    year: 2026,
    region: "中国大陆",
    description: "一群探险家在太平洋发现了一座从未被记录的岛屿，岛上隐藏着远古文明的遗迹和不可思议的秘密。",
    duration: "142分钟",
    tags: ["冒险", "奇幻", "探险", "悬疑"],
    views: 6210000,
    isHot: false,
    isNew: false,
    updateEpisode: "HD高清",
    content: "《神隐之岛》是一部融合了冒险、奇幻和悬疑元素的电影。影片以精良的特效和扣人心弦的剧情，带领观众进入一个充满未知的神秘世界。每一个场景都精心设计，每一段音乐都恰到好处。",
    director: "路阳",
    actors: ["雷佳音", "杨幂"],
    releasedAt: "2026-01-15",
  },
  {
    id: 9,
    title: "你好，星期六 2026",
    category: "variety",
    thumbnail: "https://readdy.ai/api/search-image?query=Bright%20colorful%20Chinese%20TV%20studio%20with%20hosts%20and%20guests%20playing%20games%2C%20variety%20show%20set%20design%2C%20cheerful%20atmosphere%2C%20warm%20studio%20lighting%2C%20entertainment%20show%20aesthetic&width=800&height=450&seq=video-thumb-09&orientation=landscape",
    rating: 8.2,
    year: 2026,
    region: "中国大陆",
    description: "全新升级的周六综艺，每期邀请当红明星嘉宾参与趣味游戏和深度访谈，为观众带来欢笑与感动。",
    duration: "90分钟/期",
    tags: ["综艺", "娱乐", "明星", "游戏"],
    views: 14300000,
    isHot: false,
    isNew: true,
    updateEpisode: "更新至第30期",
    content: "《你好，星期六》2026年全新升级，节目形式更加多元化，游戏环节更加有趣，嘉宾阵容也更加强大。每期节目都会带来不一样的惊喜，是周末放松的最佳选择。",
    director: "刘伟",
    actors: ["何炅", "蔡少芬"],
    releasedAt: "2026-01-03",
  },
  {
    id: 10,
    title: "斗罗大陆2：绝世唐门",
    category: "anime",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20battle%20scene%20with%20a%20young%20warrior%20summoning%20spirit%20rings%2C%20dynamic%20action%20pose%2C%20magical%20glowing%20effects%2C%20dramatic%20cloudy%20sky%2C%20anime%20aesthetic%20in%20warm%20colors&width=800&height=450&seq=video-thumb-10&orientation=landscape",
    rating: 9.0,
    year: 2026,
    region: "中国大陆",
    description: "霍雨浩的传奇旅程正式开启！全新的魂导器时代，少年与天梦冰蚕的相遇将改写整个大陆的命运。",
    duration: "22分钟/集",
    tags: ["玄幻", "热血", "3D动画", "国漫之光"],
    views: 20300000,
    isHot: true,
    isNew: true,
    updateEpisode: "更新至第24集",
    content: "《斗罗大陆2：绝世唐门》改编自唐家三少的同名小说，讲述了万年之后斗罗大陆上新一代魂师的故事。动画制作精良，战斗场面热血澎湃，是国漫爱好者的必追之作。",
    director: "沈乐平",
    actors: ["锦鲤", "刘思岑"],
    releasedAt: "2026-05-01",
  },
  {
    id: 11,
    title: "我和我的家乡3",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Warm%20Chinese%20countryside%20village%20scene%20with%20traditional%20houses%20and%20smiling%20elderly%20people%2C%20golden%20hour%20sunlight%2C%20heartwarming%20atmosphere%2C%20feel-good%20movie%20aesthetic&width=800&height=450&seq=video-thumb-11&orientation=landscape",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    description: "五段关于家乡的温情故事，由五位导演联袂打造。每一个故事都充满了对故土的深情和对美好生活的向往。",
    duration: "153分钟",
    tags: ["喜剧", "温情", "家乡", "合集"],
    views: 8750000,
    isHot: false,
    isNew: false,
    updateEpisode: "HD高清",
    content: "《我和我的家乡3》延续了系列作品的温暖风格，五段故事分别发生在中国的五个不同地区，展现了当代中国的乡村变迁和人们对家乡的深厚情感。笑中带泪，感人至深。",
    director: "宁浩",
    actors: ["黄渤", "葛优", "沈腾"],
    releasedAt: "2026-10-01",
  },
  {
    id: 12,
    title: "奇妙之城 第三季",
    category: "documentary",
    thumbnail: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20bustling%20Chinese%20city%20skyline%20at%20sunset%2C%20modern%20skyscrapers%20and%20traditional%20architecture%2C%20warm%20golden%20light%2C%20cityscape%20documentary%20aesthetic&width=800&height=450&seq=video-thumb-12&orientation=landscape",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    description: "以全新的视角探索中国最有趣的城市，从文化、美食、建筑到人文，全方位展现每座城市的独特魅力。",
    duration: "45分钟/集",
    tags: ["城市", "文化", "旅游", "纪录片"],
    views: 5980000,
    isHot: false,
    isNew: false,
    updateEpisode: "全12集",
    content: "《奇妙之城》第三季将镜头对准了中国的十二座特色城市，从北国冰城到南国花都，从古都西安到现代深圳，每一集都是一次深度的城市文化之旅。",
    director: "萧寒",
    actors: ["周轶君"],
    releasedAt: "2026-02-10",
  },
  {
    id: 13,
    title: "幕后之王",
    category: "tv",
    thumbnail: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Chinese%20TV%20production%20studio%20with%20cameras%20and%20crew%2C%20dramatic%20lighting%2C%20professional%20atmosphere%2C%20TV%20drama%20production%20aesthetic&width=800&height=450&seq=video-thumb-13&orientation=landscape",
    rating: 8.1,
    year: 2026,
    region: "中国大陆",
    description: "聚焦电视制作行业的职场故事，讲述一群幕后工作者在光鲜亮丽的娱乐圈背后经历的酸甜苦辣。",
    duration: "42分钟/集",
    tags: ["职场", "娱乐圈", "剧情", "都市"],
    views: 7820000,
    isHot: false,
    isNew: true,
    updateEpisode: "更新至第18集",
    content: "《幕后之王》是一部聚焦电视制作行业的职场剧。通过一群幕后工作者的视角，展现了光鲜亮丽的娱乐圈背后不为人知的故事。剧情真实感人，人物塑造立体饱满。",
    director: "李骏",
    actors: ["周冬雨", "罗晋"],
    releasedAt: "2026-07-01",
  },
  {
    id: 14,
    title: "天官赐福 第二季",
    category: "anime",
    thumbnail: "https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20anime%20scene%20with%20a%20god%20in%20elegant%20white%20robes%20floating%20among%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20beautiful%20anime%20art%20style&width=800&height=450&seq=video-thumb-14&orientation=landscape",
    rating: 9.1,
    year: 2026,
    region: "中国大陆",
    description: "谢怜与花城的故事继续上演，天界与人间的命运交织。绝美的画面和动人的音乐让这部动画成为年度话题之作。",
    duration: "25分钟/集",
    tags: ["仙侠", "爱情", "2D动画", "国风"],
    views: 17800000,
    isHot: true,
    isNew: false,
    updateEpisode: "更新至第18集",
    content: "《天官赐福》第二季延续了第一季的精美制作，画面每一帧都堪比壁纸级别。谢怜与花城之间的情感更加深厚，剧情也进入了更加精彩的阶段。",
    director: "李豪凌",
    actors: ["姜广涛", "马正阳"],
    releasedAt: "2026-04-05",
  },
  {
    id: 15,
    title: "极速营救",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20scene%20in%20a%20modern%20Chinese%20city%2C%20action%20movie%20aesthetic%2C%20explosions%20and%20smoke%2C%20tense%20thriller%20atmosphere%2C%20cinematic%20action%20photography&width=800&height=450&seq=video-thumb-15&orientation=landscape",
    rating: 8.3,
    year: 2026,
    region: "中国香港",
    description: "前特种兵为救被绑架的女儿孤身闯入龙潭虎穴，在限时八小时内完成不可能的营救任务。",
    duration: "128分钟",
    tags: ["动作", "犯罪", "惊悚", "港片"],
    views: 6980000,
    isHot: false,
    isNew: false,
    updateEpisode: "HD高清",
    content: "《极速营救》是一部典型的港式动作片，节奏紧凑，打斗精彩。影片在保持传统港片风格的同时，也融入了现代动作电影的元素，为观众带来了一场视觉盛宴。",
    director: "林超贤",
    actors: ["甄子丹", "谢霆锋"],
    releasedAt: "2026-03-25",
  },
  {
    id: 16,
    title: "声生不息 第四季",
    category: "variety",
    thumbnail: "https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20professional%20singers%20performing%20under%20dramatic%20spotlights%2C%20concert%20atmosphere%2C%20golden%20warm%20lighting%2C%20music%20variety%20show%20aesthetic&width=800&height=450&seq=video-thumb-16&orientation=landscape",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    description: "华语乐坛顶级歌手齐聚一堂，用歌声致敬经典，用音乐传递情感。每一期都是一场顶级音乐盛宴。",
    duration: "100分钟/期",
    tags: ["音乐", "综艺", "华语金曲", "歌手"],
    views: 13400000,
    isHot: false,
    isNew: true,
    updateEpisode: "更新至第10期",
    content: "《声生不息》第四季以全新的赛制和更强大的阵容回归。节目不仅呈现了顶级的音乐表演，也通过音乐串联起了几代人的共同记忆，是音乐爱好者不可错过的综艺节目。",
    director: "洪涛",
    actors: ["林子祥", "叶倩文"],
    releasedAt: "2026-05-10",
  },
];

export const hotVideos = videos.filter((v) => v.isHot);

export const newVideos = videos.filter((v) => v.isNew);

export const getVideosByCategory = (category: string) => {
  if (category === "all") return videos;
  return videos.filter((v) => v.category === category);
};

export const getVideoById = (id: number) => {
  return videos.find((v) => v.id === id);
};

export const getRelatedVideos = (video: VideoItem, limit: number = 6) => {
  const sameCategory = videos.filter(
    (v) => v.category === video.category && v.id !== video.id
  );
  const others = videos.filter(
    (v) => v.category !== video.category && v.id !== video.id
  );
  return [...sameCategory, ...others].slice(0, limit);
};